import { Button, Container, Label } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import useSignatureSetting from 'hooks/utils/useSignatureSetting';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import SignatureSettings from 'types/enum/SignatureSettings';
import LocalStore from 'utils/localStorageUtils';
import HeaderDialog from '../../HeaderDialog/HeaderDialog';
import './SignatureSettingsDialog.scss';
import SignatureSettingsSelect from './SignatureSettingsSelect/SignatureSettingsSelect';

export interface ISignatureSettingsDialogProps {
  className?: string | object;
  isOpen: boolean;
  onClose: () => void;
}

const SignatureSettingsDialog = (props: ISignatureSettingsDialogProps) => {
  const { className, isOpen, onClose } = props;

  const localSignatureSetting = LocalStore.get('signatureSetting');
  const [currentSetting, setCurrentSetting] = useState<SignatureSettings>(SignatureSettings.TYPE_SIGNATURE);
  const { setSignatureSetting } = useSignatureSetting();

  useEffect(() => {
    setCurrentSetting(localSignatureSetting);
  }, [localSignatureSetting]);

  function onChange(value: SignatureSettings) {
    setCurrentSetting(value);
  }

  function onSubmit() {
    setSignatureSetting(currentSetting);
    onClose();
  }

  const classes = classNames('signature-settings-dialog', className);

  return (
    <HeaderDialog isOpen={isOpen} title={t('Signature Settings')} onClose={onClose} divider={false} className={classes}>
      <Container className={'py-4 px-8'}>
        <Label>{t('Signature Options')}</Label>
        <span>{t('How would you like to sign off on items in the busybusy web app?')}</span>
        <SignatureSettingsSelect className={'mt-4'} onChange={onChange} value={currentSetting} />
        <Button className={'my-4'} type={'primary'} onClick={onSubmit}>
          {t('Update')}
        </Button>
      </Container>
    </HeaderDialog>
  );
};

export default SignatureSettingsDialog;
